<app-text-area
	[allowResize]="false"
	label="Instrument text"
	height="100%"
	[disabled]="disabled"
	name="originalText"
	[initialValue]="initialValueText.text"
	[labelEndType]="disabled ? 'none' : 'revert'"
	[ngModel]="value.text"
	(ngModelChange)="_onChange('text', $event)"
	[testHook]="testHooks.InstrumentTextTextArea"
></app-text-area>
<app-text-area
	[allowResize]="false"
	label="Requisition text"
	height="100%"
	[disabled]="disabled"
	name="originalRequiredText"
	[initialValue]="initialValueText.requisitionText"
	[labelEndType]="disabled ? 'none' : 'revert'"
	[ngModel]="value.requisitionText"
	(ngModelChange)="_onChange('requisitionText', $event)"
	[testHook]="testHooks.RequisitionTextTextArea"
></app-text-area>
